import React, { useState } from "react";
import supabase from "../supabase/supabaseClient";

function Enviar() {
  const [activar, setActivar] = useState(false);
  const [nombre, setNombre] = useState("");
  const [comentario, setComentario] = useState("");

  function comentar() {
    setActivar(!activar);
  }

  function capturarNombre(e) {
    setNombre(e.target.value);
  }

  function capturarComentario(e) {
    setComentario(e.target.value);
  }

  async function enviarComentario(e) {
    e.preventDefault();
    const { data, error } = await supabase
      .from("comentarios")
      .insert({ nombre: nombre, comentario: comentario });

    setNombre("");
    setComentario("");
    setActivar(!activar);
  }
  return (
    <div className="inicio">
      <button
        onClick={comentar}
        className={activar ? "botonActivar botonActivarNo" : "botonActivar"}
      >
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M20 2H4c-1.103 0-2 .897-2 2v18l4-4h14c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM8.999 14.987H7v-1.999l5.53-5.522 1.998 1.999-5.529 5.522zm6.472-6.464-1.999-1.999 1.524-1.523L16.995 7l-1.524 1.523z"></path>
        </svg>
      </button>

      {activar ? (
        <form onSubmit={enviarComentario}>
          <label>Deja tu comentario</label>
          <input
            onChange={capturarNombre}
            value={nombre}
            placeholder="Nombre"
            required
          />
          <textarea
            onChange={capturarComentario}
            value={comentario}
            placeholder="Comentario"
            required
          />
          <button type="submit" className="botonEnviar">
            Enviar
          </button>
        </form>
      ) : null}
    </div>
  );
}

export default Enviar;
